export enum MitarbeiterRole {
  ADMIN = 'admin',
  INTERN = 'intern',
  EXTERN = 'extern',
}
